var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrosoft365 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icons/minus",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "microsoft",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.447,0 L8.553,0 C7.97144416,0 7.5,0.471444158 7.5,1.053 L7.5,2.25 L14.7675,4.5 L22.5,2.25 L22.5,1.053 C22.5,0.471444158 22.0285558,0 21.447,0 Z",
  id: "Path",
  fill: "#0364B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.7375,11.55375 C23.8473561,11.20845 23.9350348,10.8564828 24,10.5 C23.9997931,10.321753 23.9046166,10.1571235 23.75025,10.068 L23.7405,10.062 L23.7375,10.0605 L15.609,5.43 C15.27605,5.21524101 14.8546379,5.19159179 14.49975,5.36775 C14.4623815,5.38620602 14.4260748,5.4067381 14.391,5.42925 L6.2625,10.06125 L6.2595,10.06275 L6.2505,10.068 C6.09584467,10.1569328 6.0003616,10.3215982 6,10.5 C6.06497123,10.8564815 6.15264978,11.2084483 6.2625,11.55375 L14.8815,17.8575 L23.7375,11.55375 Z",
  id: "Path",
  fill: "#0A2767"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#28A8EA",
  points: "18 2.25 12.75 2.25 11.23425 4.5 12.75 6.75 18 11.25 22.5 11.25 22.5 6.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#0078D4",
  points: "7.5 2.25 12.75 2.25 12.75 6.75 7.5 6.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#50D9FF",
  points: "18 2.25 22.5 2.25 22.5 6.75 18 6.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#0364B8",
  points: "18 11.25 12.75 6.75 7.5 6.75 7.5 11.25 12.75 15.75 20.874 17.076"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#0078D4",
  points: "12.75 6.75 18 6.75 18 11.25 12.75 11.25"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#064A8C",
  points: "7.5 11.25 12.75 11.25 12.75 15.75 7.5 15.75"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#0078D4",
  points: "18 11.25 22.5 11.25 22.5 15.75 18 15.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1425,17.4135 L6.29775,10.9635 L6.669,10.311 L14.85075,14.97 C14.9524737,15.0107066 15.0665165,15.0074482 15.16575,14.961 L23.3655,10.2885 L23.7375,10.94025 L15.1425,17.4135 Z",
  id: "Path",
  fill: "#0A2767",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.75025,10.93275 L23.73975,10.93875 L23.7375,10.94025 L15.609,15.57075 C15.2807223,15.7824273 14.866022,15.8082751 14.514,15.639 L17.3445,19.43475 L23.535,20.7825 L23.535,20.7855 C23.8271106,20.5741887 24,20.2355289 24,19.875 L24,10.5 C24,10.678515 23.9048485,10.8434925 23.75025,10.93275 L23.75025,10.93275 Z",
  id: "Path",
  fill: "#1490DF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24,19.875 L24,19.3215 L16.51275,15.0555 L15.609,15.57075 C15.2807223,15.7824273 14.866022,15.8082751 14.514,15.639 L17.3445,19.43475 L23.535,20.7825 L23.535,20.7855 C23.8271106,20.5741887 24,20.2355289 24,19.875 L24,19.875 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.05
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.9625,20.16225 L15.75525,15.4875 L15.609,15.57 C15.2808558,15.7819195 14.8661506,15.8080516 14.514,15.639 L17.3445,19.43475 L23.535,20.7825 L23.535,20.7855 C23.7449214,20.6334093 23.8959219,20.4135314 23.9625,20.163 L23.9625,20.16225 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.2625,10.9425 L6.2625,10.935 L6.255,10.935 L6.2325,10.92 C6.08666228,10.8305044 5.99842121,10.6711012 5.99997916,10.5 L5.99997916,19.875 C5.99960121,20.1734906 6.1179996,20.4598705 6.32906453,20.6709355 C6.54012946,20.8820004 6.82650937,21.0003988 7.125,21 L22.875,21 C22.9686991,20.9990823 23.0619181,20.9864851 23.1525,20.9625 C23.1994941,20.9543235 23.2449988,20.9391553 23.2875,20.9175 C23.3034369,20.9159465 23.3188184,20.9108193 23.3325,20.9025 C23.3938827,20.8774069 23.4518432,20.8446467 23.505,20.805 C23.52,20.7975 23.5275,20.7975 23.535,20.7825 L6.2625,10.9425 Z",
  id: "Path",
  fill: "#28A8EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5,17.00025 L13.5,4.74975 C13.4983526,4.19828714 13.0517129,3.7516474 12.50025,3.75 L7.5225,3.75 L7.5225,9.342 L6.2625,10.0605 L6.25875,10.062 L6.24975,10.06725 C6.09515146,10.1565075 5.99999997,10.321485 5.99999997,10.5 L5.99999997,10.50375 L5.99999997,10.5 L5.99999997,18 L12.50025,18 C13.0517129,17.9983526 13.4983526,17.5517129 13.5,17.00025 L13.5,17.00025 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.75,17.75025 L12.75,5.49975 C12.7483526,4.94828714 12.3017129,4.5016474 11.75025,4.5 L7.5225,4.5 L7.5225,9.342 L6.2625,10.0605 L6.25875,10.062 L6.24975,10.06725 C6.09515146,10.1565075 5.99999997,10.321485 5.99999997,10.5 L5.99999997,10.50375 L5.99999997,10.5 L5.99999997,18.75 L11.75025,18.75 C12.3017129,18.7483526 12.7483526,18.3017129 12.75,17.75025 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.75,16.25025 L12.75,5.49975 C12.7483526,4.94828714 12.3017129,4.5016474 11.75025,4.5 L7.5225,4.5 L7.5225,9.342 L6.2625,10.0605 L6.25875,10.062 L6.24975,10.06725 C6.09515146,10.1565075 5.99999997,10.321485 5.99999997,10.5 L5.99999997,10.50375 L5.99999997,10.5 L5.99999997,17.25 L11.75025,17.25 C12.3017129,17.2483526 12.7483526,16.8017129 12.75,16.25025 L12.75,16.25025 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,16.25025 L12,5.49975 C11.9983526,4.94828714 11.5517129,4.5016474 11.00025,4.5 L7.5225,4.5 L7.5225,9.342 L6.2625,10.0605 L6.25875,10.062 L6.24975,10.06725 C6.09515146,10.1565075 5.99993914,10.321485 5.99999997,10.5 L5.99999997,10.50375 L5.99999997,10.5 L5.99999997,17.25 L11.00025,17.25 C11.5517129,17.2483526 11.9983526,16.8017129 12,16.25025 L12,16.25025 Z",
  id: "Path",
  fill: "#000000",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.99975,4.5 L11.00025,4.5 C11.5523967,4.5 12,4.94760332 12,5.49975 L12,15.50025 C12,16.0523967 11.5523967,16.5 11.00025,16.5 L0.99975,16.5 C0.447603321,16.5 0,16.0523967 0,15.50025 L0,5.49975 C0,4.94760332 0.447603321,4.5 0.99975,4.5 Z",
  id: "Path",
  fill: "#0078D4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.90025,8.601 C3.16589927,8.03484346 3.59476777,7.56105085 4.13175,7.2405 C4.72666457,6.89994118 5.40404059,6.73020788 6.08925,6.75 C6.72371277,6.73623678 7.34975696,6.89709356 7.899,7.215 C8.41601099,7.5229557 8.83239281,7.9745137 9.0975,8.51475 C9.38630494,9.11022794 9.53021987,9.76555485 9.5175,10.42725 C9.53138781,11.1184004 9.38317855,11.803194 9.08475,12.42675 C8.81387512,12.9862143 8.38493966,13.4540017 7.851,13.77225 C7.28021376,14.1002889 6.63040293,14.2655302 5.97225,14.25 C5.32385957,14.2654394 4.68364846,14.1027926 4.12125,13.77975 C3.60010807,13.4712922 3.17882097,13.0192808 2.90775,12.47775 C2.61696557,11.8910656 2.47113675,11.2431946 2.4825,10.5885 C2.46992386,9.90295833 2.61274503,9.22346802 2.90025,8.601 L2.90025,8.601 Z M4.21275,11.7945 C4.35426975,12.1524022 4.59428658,12.4628899 4.905,12.69 C5.22161723,12.9116072 5.60090533,13.0259456 5.98725,13.01625 C6.39881872,13.0322555 6.80444117,12.9140696 7.143,12.6795 C7.4502533,12.4525147 7.68416269,12.1403747 7.81575,11.78175 C7.96329408,11.382195 8.03600634,10.9588877 8.03025,10.533 C8.03482415,10.1030754 7.96635062,9.67549623 7.82775,9.2685 C7.70545161,8.90235858 7.47989377,8.57938892 7.17825,8.3385 C6.84861959,8.0921358 6.44417652,7.96685645 6.033,7.98375 C5.63824636,7.97377147 5.25046806,8.08902852 4.92525,8.313 C4.60843781,8.54049696 4.36288076,8.85342613 4.21725,9.21525 C3.89509323,10.0447434 3.89322173,10.9644524 4.212,11.79525 L4.21275,11.7945 Z",
  id: "Shape",
  fill: "#FFFFFF"
})))));
export { SvgMicrosoft365 as ReactComponent };
export default __webpack_public_path__ + "images/microsoft365.svg";